// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********** Template CSS **********/
:root {
    --primary: #1E60AA;
    --secondary: #FF4917;
    --light: #EDF1FC;
    --dark: #17224D;
}

.fw-medium {
    font-weight: 600 !important;
}

.back-to-top {
    position: fixed;
    display: none;
    right: 20px;
    bottom: 20px;
    z-index: 99;
}

.login{
    margin:  10px 10px;
}
.update{
    margin:  10px 10px;
}


/*** Spinner ***/
#spinner {
    opacity: 0;
    visibility: hidden;
    transition: opacity .5s ease-out, visibility 0s linear .5s;
    z-index: 99999;
}

#spinner.show {
    transition: opacity .5s ease-out, visibility 0s linear 0s;
    visibility: visible;
    opacity: 1;
}


/*** Button ***/
.btn {
    font-weight: 600;
    transition: .5s;
}

.btn.btn-primary,
.btn.btn-secondary {
    color: #FFFFFF;
}

.btn-square {
    width: 38px;
    height: 38px;
}

.btn-sm-square {
    width: 32px;
    height: 32px;
}

.btn-lg-square {
    width: 48px;
    height: 48px;
}

.btn-square,
.btn-sm-square,
.btn-lg-square {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
}

.pseudo-btn {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    color: #FFFFFF;
    border: 1px solid var(--primary, #1E60AA);
    background-color: transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    border-radius: 0px;
}

/*** Navbar ***/
.top-bar {
    padding: 0 3rem;
}

.nav-bar {
    top: 0;
    padding: 0 100px;
    margin-bottom: 10px;
    width: 100%;
}

.navbar-light .navbar-nav .nav-link {
    margin-right: 30px;
    padding: 25px 0;
    color: var(--dark, #17224D);
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
    outline: none;
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link.active {
    color: var(--primary, #1E60AA);
}

.navbar-brand {
    height: 125px;
    border-radius: 25px;
}

@media (max-width: 991.98px) {
    .nav-bar {
        padding: 0;
        height: 75px;
    }

    .navbar-light .navbar-nav .nav-link  {
        margin-right: 0;
        padding: 10px 0;
    }

    .navbar-light .navbar-nav {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid #EEEEEE;
    }

    .nav-icon {
        display: block;
        position: absolute;
        top: 20px;
        right: 0;
        transform: translate(-100%, -50%);
        width: 2rem;
        height: 2rem;
        cursor: pointer;
    }
    .navbar-nav {
        display: none !important;
    }
    .login{
        display: none !important;
    }
    .update{
        display: none !important;
    }

    .navbar-nav.active {
        display: flex !important;
        flex-direction: column;
        position: absolute;
        top: 58px;
        right: 0;
        opacity: 1;
        transition: all 0.5s ease;
    }
    .navbar-brand {
        max-height: 60px;
        height: -webkit-fill-available;
        border-radius: 10px;
    }
}

@media (min-width: 992px) {
    .nav-icon {
        display: none;
    }

}

.footer {
    place-items:  anchor-center;
    bottom: 0;
    width: 100%;
}
.contactItem{
    width: auto !important;
    margin-left: 10px;
    margin-right: 10px;
}

.calendar {
    width: 90%;
    margin-left: 5%;
    margin-bottom: 10px;
}

.calendarEvent{
    white-space: normal;
}

.acts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
}

.grid-manager {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
}

.act-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
}



.modal-top-right .modal-dialog {
    position: fixed;
    top: 10px;
    right: 10px;
    margin: 0;
    /* Optional: Adjust width as needed */
    max-width: 400px;
}

.modal-top-right .modal-content {
    /* Ensure the modal content has a high z-index */
    z-index: 10500;
}

.button-spacing {
    margin: 8px; /* Adjust as needed */
}

.blurp-img {
    max-width: 100px;
    max-height: 100px;
    width: auto;
    height: auto;
    display: block;
    margin: 0 auto 8px auto;
    object-fit: contain;
}

.blurp-name {
    font-size: 1.5rem;
    color:  #1976d2;
    font-weight: bold;
    text-align: center;
    margin-bottom: 4px;
}

.blurp-text {
    max-width: 200px;
    word-break: break-word;
    white-space: pre-line;
    text-align: center;
    margin: 0 auto 8px auto;
    display: block;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;;AAGA,gBAAgB;AAChB;IACI,UAAU;IACV,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;AAClB;;AAEA;IACI,yDAAyD;IACzD,mBAAmB;IACnB,UAAU;AACd;;;AAGA,eAAe;AACf;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,yCAAyC;IACzC,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI,eAAe;AACnB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,iCAAiC;QACjC,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,gBAAgB;QAChB,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI,2BAA2B;IAC3B,SAAS;IACT,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,SAAS;IACT,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,WAAW,EAAE,qBAAqB;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;AAClB","sourcesContent":["/********** Template CSS **********/\n:root {\n    --primary: #1E60AA;\n    --secondary: #FF4917;\n    --light: #EDF1FC;\n    --dark: #17224D;\n}\n\n.fw-medium {\n    font-weight: 600 !important;\n}\n\n.back-to-top {\n    position: fixed;\n    display: none;\n    right: 20px;\n    bottom: 20px;\n    z-index: 99;\n}\n\n.login{\n    margin:  10px 10px;\n}\n.update{\n    margin:  10px 10px;\n}\n\n\n/*** Spinner ***/\n#spinner {\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity .5s ease-out, visibility 0s linear .5s;\n    z-index: 99999;\n}\n\n#spinner.show {\n    transition: opacity .5s ease-out, visibility 0s linear 0s;\n    visibility: visible;\n    opacity: 1;\n}\n\n\n/*** Button ***/\n.btn {\n    font-weight: 600;\n    transition: .5s;\n}\n\n.btn.btn-primary,\n.btn.btn-secondary {\n    color: #FFFFFF;\n}\n\n.btn-square {\n    width: 38px;\n    height: 38px;\n}\n\n.btn-sm-square {\n    width: 32px;\n    height: 32px;\n}\n\n.btn-lg-square {\n    width: 48px;\n    height: 48px;\n}\n\n.btn-square,\n.btn-sm-square,\n.btn-lg-square {\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: normal;\n}\n\n.pseudo-btn {\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    color: #FFFFFF;\n    border: 1px solid var(--primary, #1E60AA);\n    background-color: transparent;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    border-radius: 0px;\n}\n\n/*** Navbar ***/\n.top-bar {\n    padding: 0 3rem;\n}\n\n.nav-bar {\n    top: 0;\n    padding: 0 100px;\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.navbar-light .navbar-nav .nav-link {\n    margin-right: 30px;\n    padding: 25px 0;\n    color: var(--dark, #17224D);\n    font-size: 15px;\n    font-weight: 600;\n    text-transform: uppercase;\n    outline: none;\n}\n\n.navbar-light .navbar-nav .nav-link:hover,\n.navbar-light .navbar-nav .nav-link.active {\n    color: var(--primary, #1E60AA);\n}\n\n.navbar-brand {\n    height: 125px;\n    border-radius: 25px;\n}\n\n@media (max-width: 991.98px) {\n    .nav-bar {\n        padding: 0;\n        height: 75px;\n    }\n\n    .navbar-light .navbar-nav .nav-link  {\n        margin-right: 0;\n        padding: 10px 0;\n    }\n\n    .navbar-light .navbar-nav {\n        margin-top: 1rem;\n        padding-top: 1rem;\n        border-top: 1px solid #EEEEEE;\n    }\n\n    .nav-icon {\n        display: block;\n        position: absolute;\n        top: 20px;\n        right: 0;\n        transform: translate(-100%, -50%);\n        width: 2rem;\n        height: 2rem;\n        cursor: pointer;\n    }\n    .navbar-nav {\n        display: none !important;\n    }\n    .login{\n        display: none !important;\n    }\n    .update{\n        display: none !important;\n    }\n\n    .navbar-nav.active {\n        display: flex !important;\n        flex-direction: column;\n        position: absolute;\n        top: 58px;\n        right: 0;\n        opacity: 1;\n        transition: all 0.5s ease;\n    }\n    .navbar-brand {\n        max-height: 60px;\n        height: -webkit-fill-available;\n        border-radius: 10px;\n    }\n}\n\n@media (min-width: 992px) {\n    .nav-icon {\n        display: none;\n    }\n\n}\n\n.footer {\n    place-items:  anchor-center;\n    bottom: 0;\n    width: 100%;\n}\n.contactItem{\n    width: auto !important;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.calendar {\n    width: 90%;\n    margin-left: 5%;\n    margin-bottom: 10px;\n}\n\n.calendarEvent{\n    white-space: normal;\n}\n\n.acts-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 16px;\n}\n\n.grid-manager {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 16px;\n}\n\n.act-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n\n\n.modal-top-right .modal-dialog {\n    position: fixed;\n    top: 10px;\n    right: 10px;\n    margin: 0;\n    /* Optional: Adjust width as needed */\n    max-width: 400px;\n}\n\n.modal-top-right .modal-content {\n    /* Ensure the modal content has a high z-index */\n    z-index: 10500;\n}\n\n.button-spacing {\n    margin: 8px; /* Adjust as needed */\n}\n\n.blurp-img {\n    max-width: 100px;\n    max-height: 100px;\n    width: auto;\n    height: auto;\n    display: block;\n    margin: 0 auto 8px auto;\n    object-fit: contain;\n}\n\n.blurp-name {\n    font-size: 1.5rem;\n    color:  #1976d2;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 4px;\n}\n\n.blurp-text {\n    max-width: 200px;\n    word-break: break-word;\n    white-space: pre-line;\n    text-align: center;\n    margin: 0 auto 8px auto;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
